const Template =`<div>
<div class="adding-window">
<h1>{{$t('addModem.addModemh1')}}</h1>

<b-tabs content-class="mt-3">

<b-tab :title="$t('addModem.manually')">

<div class="info">
<div class="info-form">
<template>
  <b-container fluid>
  <b-row >
  <b-col sm="6" v-for="type in types">
    <label for="input-live">{{type.namelabel}}</label>
    <b-form-input
      v-bind:id="type.key"
      v-model="type.info"
      :state="validInput(type.info)"
      trim
    ></b-form-input>
    <b-form-invalid-feedback id="input-live-feedback">
    {{description}}
    </b-form-invalid-feedback>
    </b-col>

    <b-col sm="6" class="hidden">
            <img id='qr-code' src=''>
            <label class="qr-label">{{$t('addModem.scanQR')}} <br>
              <a id="qrScannerLink" href=''>{{$t('addModem.qrLink')}}.</a>
            </label>
      </b-col>

    </b-row>

    <b-row >
    <b-col sm="6" v-for="comment_type in comment_types" v-bind:key="comment_type.id">
    <label for="input-live">{{comment_type.namelabel}}</label>
    <b-form-textarea
    v-model="comment_type.info"
    :type="comment_type.typefield"
    :placeholder="$t('addModem.enterComment')"
  ></b-form-textarea>
  </b-col>
  </b-row>

  <b-row>
  <b-col sm="6">
  <label for="input-live">{{$t('addModem.modemCoords')}}</label>
    <b-form-input
      :state="validCoords(modem_coords)"
      trim
      placeholder="27.68925, 53.94542"
      v-model="modem_coords">
      </b-form-input>
    <b-form-invalid-feedback id="input-live-feedback">
      {{description_coords}}
    </b-form-invalid-feedback>
    </b-col>

  <b-col sm="6">
  <label for="input-live">{{$t('addModem.tubeCoords')}}</label>
    <b-form-input
    :state="validCoords(tube_coords)"
      trim
      v-model="tube_coords"
      placeholder="[27.6892,53.9454] [27.6892,53.94542]"
    ></b-form-input>
    <b-form-invalid-feedback id="input-live-feedback">
      {{description_coords}}
    </b-form-invalid-feedback>
    </b-col>
  </b-row>


  <b-row >
  <b-col>
    <label>{{$t('addModem.addContacts')}}</label>
    <b-form-checkbox-group 
    class="contacts"
    v-model="selected_phone"
    :options="phones"
    stacked>
    </b-form-checkbox-group>
  </b-col>
  </b-row>
  <b-row class="phones-button">
  <b-col sm="2.9">
   <b-button v-on:click="deleteAllPhones">{{$t('addModem.resetAll')}}</b-button>
   </b-col>
   <b-col sm="2.9">
   <b-button class="add-modem"
   v-on:click="checkAllPhones">{{$t('addModem.chooseAll')}}</b-button>
   </b-col>
  </b-row>
  

  <b-row class="main-button">
  <b-col sm="3">
  </b-col>
  <b-col sm="3">
  </b-col>
   <b-col sm="3.6">
   <b-button
   :disabled="validModem"
   v-on:click="createAndContinue">{{$t('addModem.addAndContinue')}}</b-button>
   </b-col>
   <b-col sm="2.4">
   <b-button class="add-modem"
   :disabled="validModem"
   v-on:click="createAndDelete">{{$t('addModem.addModemButton')}}</b-button>
   </b-col>
  </b-row>

  </b-container>
</template>

<b-modal body-bg-variant="pink" ref="messageModal" hide-footer :title="$t('addModem.addStatus')">
      <div class="d-block text-center">
        <h4>{{message}}</h4>
      </div>
      <b-button class="mt-3" variant="outline-danger" block 
      v-on:click="hideModal">{{$t('addModem.ok')}}</b-button>
</b-modal>
</div>
</div>

</b-tab>



<b-tab :title="$t('addModem.fromFile')">
<p>In process</p>
</b-tab>

</b-tabs>
</div>
</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page4_addmodem/form_window/template.js